import { render, staticRenderFns } from "./UserRevokeRoleAction.vue?vue&type=template&id=048cddf2"
import script from "./UserRevokeRoleAction.vue?vue&type=script&lang=js"
export * from "./UserRevokeRoleAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports